import React from 'react'
import Box from '@material-ui/core/Box'
import { Select } from '@material-ui/core'
import { useHistory, useLocation } from 'react-router-dom'
import { LANGUAGE_LIST } from 'src/i18n'
import { setLanguage } from 'src/store/slices/authSlice'
import { useDispatch } from 'react-redux'
import useUserSession from 'src/hooks/useUserSession'
import { ReactComponent as FooterIcon7 } from 'src/mobile/assets/icons/footer_icon7.svg'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { changePathName } from 'src/utils/replaceURLs'

const userStyles = makeStyles((theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.contrastText,
      padding: 0,
    },
    boxBottomText: {
      cursor: 'pointer',
      color: 'theme.palette.primary.main',
      fontSize: 14,
      display: 'inline-block',
      textDecoration: 'underline',
      marginRight: theme.spacing(4),
      marginTop: theme.spacing(3.2),
    },
    boxBottomText2: {
      display: 'flex',
      textDecoration: 'underline',
      color: 'black',
      '& .MuiSelect-select': {
        fontSize: 14,
        color: '#111827',
      },
    },
  }),
)

const Footer = React.forwardRef((props, ref) => {
  const classes = userStyles()
  const history = useHistory()
  const { pathname } = useLocation()
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const { userInfo, authenticated } = useUserSession()
  const FooterBottomText = [
    {
      label: t('glossary.agreement'),
      path: '/agreement/3',
    },
    {
      label: t('glossary.policy_and_agreement_list.4'),
      path: '/agreement/2',
    },
    {
      label: t('glossary.policy_and_agreement_list.5'),
      path: '/agreement/1',
    },
  ]
  const handleChangeLanguage = async (e) => {
    const language = e.target.value
    language && i18n.changeLanguage(language)
    if (authenticated && userInfo?.id)
      await dispatch(setLanguage({ id: userInfo?.id, language: language })).unwrap()
    changePathName(language, history, pathname)
  }
  return (
    <Box
      ref={ref}
      // className={classes.root}
    >
      <Box display="flex" backgroundColor="white">
        <Box mt={3} mb={3} mr={1.5} ml={16} className={classes.boxBottomText2}>
          <FooterIcon7 />
          <Box mt={-0.4} ml={1}>
            <Box>
              <Select
                disableUnderline
                native
                keepMounted
                defaultValue={i18n.language}
                onChange={handleChangeLanguage}
                IconComponent={() => null}
              >
                {LANGUAGE_LIST.map((language, index) => (
                  <option key={language.lang + index} value={language.lang}>
                    {t(language.label)}
                  </option>
                ))}
              </Select>
            </Box>
          </Box>
        </Box>
        <Box>
          {FooterBottomText.map((item, index) => (
            <Box
              key={index}
              mt={3}
              mb={3}
              fontSize={14}
              color="black"
              className={classes.boxBottomText}
              onClick={() => {
                history.push(item.path)
              }}
            >
              {item.label}
            </Box>
          ))}
        </Box>
        <Box mt={3} ml="auto" fontSize={14} pr={16} color="#4B5563">
          {' '}
          {t('glossary.reserved')}{' '}
        </Box>
      </Box>
    </Box>
  )
})

export default Footer
